// extracted by mini-css-extract-plugin
module.exports = {"baseButton":"Button_baseButton__4_xQP","primary":"Button_primary__19no6","secondary":"Button_secondary__OBzgL","disabled":"Button_disabled__2MkOE","danger":"Button_danger__2P7yK"};